"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MailTemplates = void 0;
var MailTemplates;
(function (MailTemplates) {
    MailTemplates["answer_notification"] = "AnswerNotification";
    MailTemplates["payment_notification"] = "PaymentNotification";
    MailTemplates["document_refused_notification"] = "DocumentRefusedNotification";
    MailTemplates["document_approved_notification"] = "DocumentApprovedNotification";
    MailTemplates["period_notification"] = "PeriodNotification";
    MailTemplates["inquiry_notification"] = "InquiryNotification";
})(MailTemplates = exports.MailTemplates || (exports.MailTemplates = {}));
